module.exports = __webpack_public_path__ + "img/mision4.09050ccc.png";